// Rilevamento della pagina di login desktop (browser) servita da /login.
// Caso 1: arrivo dall'app con ?desktop_challenge=... (query presente).
// Caso 2: ritorno dal redirect OAuth Google (`#id_token=...`): Google riporta su
// /login senza query, quindi la challenge sopravvive solo in sessionStorage.
// Senza il caso 2 la SPA monta il login web e l'app Electron resta in attesa.
export function isDesktopLoginEntry(opts: {
  search: string;
  hash: string;
  hasStoredChallenge: boolean;
}): boolean {
  try {
    if (new URLSearchParams(opts.search).has('desktop_challenge')) return true;
    return opts.hash.includes('id_token=') && opts.hasStoredChallenge;
  } catch {
    return false;
  }
}

// La porta loopback arriva dall'app (?desktop_loopback=<porta>): accetta solo
// interi 1..65535, altrimenti il flusso resta sul deep-link di fallback.
export function parseDesktopLoopbackPort(raw: string | null | undefined): number | null {
  if (raw == null || raw === '') return null;
  const n = Number(raw);
  if (!Number.isInteger(n) || n < 1 || n > 65535) return null;
  return n;
}

// RFC 8252: con porta loopback nota si naviga top-level al server locale (deterministico,
// nessun gesto utente); senza porta si conserva il deep-link jarvis:// di fallback.
export function resolveDesktopDelivery(
  callbackUrl: string,
  loopbackPort: number | null
): { url: string; loopback: boolean } {
  if (loopbackPort == null) return { url: callbackUrl, loopback: false };
  try {
    const code = new URL(callbackUrl).searchParams.get('code');
    if (!code) return { url: callbackUrl, loopback: false };
    const url = `http://127.0.0.1:${loopbackPort}/desktop-callback?code=${encodeURIComponent(code)}`;
    return { url, loopback: true };
  } catch {
    return { url: callbackUrl, loopback: false };
  }
}
